var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"webLayout"},[(_vm.isMobile==='none')?_c('div'):(!_vm.isMobile)?_c('header-index'):_c('header-index-app'),_c('div',{class:{ main: true,mainPadding: !_vm.isMobile  }},[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view',{key:_vm.key})],1)],1),(!_vm.isMobile)?_c('footer-index'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }